import SessionExpiringDialog from 'tio-common/components/auth/session-expiring-dialog';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SessionContextService from 'tio-employee/services/session-context';
import type SessionService from 'tio-employee/services/session';

export default class AuthSessionExpiringDialogComponent extends Component {
  @service declare session: SessionService;
  @service declare sessionContext: SessionContextService;

  renew = () => {
    this.session.renew();
  };

  logout = () => {
    this.sessionContext.logout();
  };

  <template>
    <SessionExpiringDialog
      @isSessionExpiring={{this.session.isSessionExpiring}}
      @expireAt={{this.session.expireAt}}
      @onRenew={{this.renew}}
      @onLogout={{this.logout}}
    />
  </template>
}
